import React from "react"
import { Auth } from "../../../Components/Views/Auth/Auth"
import { RouteComponentProps } from "react-router"
import { AuthFormView } from "../../../Models/Client/AuthFormView"

export interface AuthRouteParams {
    redirectTo?: string
    email?: string
    collaborationId?: string
    provider?: string
}

export function encodeAuthParams(
    params: AuthRouteParams
): URLSearchParams | undefined {
    const entries = (
        params.redirectTo === undefined
            ? []
            : [["redirectTo", params.redirectTo]]
    )
        .concat(params.email === undefined ? [] : [["email", params.email]])
        .concat(
            params.collaborationId === undefined
                ? []
                : [["collaborationId", params.collaborationId]]
        )

    return entries.length > 0 ? new URLSearchParams(entries) : undefined
}

export function decodeAuthParams(query: URLSearchParams): AuthRouteParams {
    return {
        redirectTo: query.get("redirectTo") ?? undefined,
        email: query.get("email") ?? undefined,
        collaborationId: query.get("collaborationId") ?? undefined,
        provider: query.get("provider") ?? undefined
    }
}

export function SigninRoute({ location }: RouteComponentProps) {
    return (
        <Auth
            type={AuthFormView.login}
            squashSuccessMessage={false}
            {...decodeAuthParams(new URLSearchParams(location.search))}
        />
    )
}
